import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKingodmCash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6.2959,
			y: 7.48242,
			width: 16.2826,
			height: 12.5564,
			rx: 4.30986,
			stroke: "currentColor",
			strokeWidth: 1.6162
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.3859 5.68878C17.5073 4.1354 15.8401 3.08691 13.9281 3.08691H6.53984C3.71327 3.08691 1.42188 5.3783 1.42188 8.20487V12.1416C1.42188 14.1331 2.55943 15.859 4.22024 16.7049V14.7649C3.49519 14.1234 3.03807 13.1858 3.03807 12.1416V8.20487C3.03807 6.27091 4.60587 4.70311 6.53984 4.70311H13.9281C14.8746 4.70311 15.7334 5.07862 16.3636 5.68878H18.3859Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.3507,
			cy: 13.7604,
			r: 2.15493,
			stroke: "currentColor",
			strokeWidth: 1.6162
		})
	]
});
export default SvgKingodmCash;
